// Estados de la cola de reels de Instagram — deben reflejar exactamente los mismos valores
// que backend/ig_reels.py (STATUSES).
export const STATUS_LABELS = {
  queued: "En cola", rendering: "Renderizando", ready: "Listo", publishing: "Publicando",
  published: "Publicado", error: "Error",
};
export const STATUS_COLORS = {
  queued: "bg-slate-100 text-slate-600", rendering: "bg-amber-100 text-amber-700",
  ready: "bg-blue-100 text-blue-700", publishing: "bg-amber-100 text-amber-700",
  published: "bg-emerald-100 text-emerald-700", error: "bg-rose-100 text-rose-700",
};

export function fmtDateTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("es-ES", {
      day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    });
  } catch { return null; }
}
